import React from "react";
import KonfhubContainer from "../../../revampComponents/Atom/Container";
import { dashboardColors, theme } from "../../../themes/Theme";
import widgetIcon from "../../../assets/images/widget-icon.svg";
import { useHistory, useParams } from "react-router-dom";

const WidgetEmptyState = (props) => {
  const history = useHistory();
  const onClickHandler = (widgetId = null) => {
    history.push({
      pathname: widgetId
        ? `/e/${props?.eventInfo?.event_id}/developers/embed/edit/${widgetId}`
        : `/e/${props?.eventInfo?.event_id}/developers/embed/create`,
    });
  };
  return (
    <KonfhubContainer>
      <div className="widget-empty-state-container d-flex flex-column justify-content-center align-items-center ">
        <img src={widgetIcon} alt="widgetIcon" />
        <div
          style={{ maxWidth: "430px" }}
          className=" text-center d-flex flex-column richtext-gap-2 justify-content-center align-items-center"
        >
          <p className="no-widget-title mb-0">No Widgets Created!</p>
          <p className="no-widget-desc mb-0">
            Customize and embed your event ticketing widget to blend perfectly
            in your event website.
          </p>
        </div>

        <button
          type="button"
          class="k-btn save-btn position-relative"
          onClick={() => onClickHandler()}
        >
          Create Widget
        </button>
      </div>
      <style jsx>
        {`
          .widget-empty-state-container {
            border: 1px dashed ${dashboardColors[theme].primary};
            min-height: 300px;
            gap: 20px;
          }
          .no-widget-title {
            font-size: 18px;
            font-weight: 500;
            color: ${dashboardColors[theme].primaryTextColor};
          }
          .no-widget-desc {
            font-size: 16px;
            font-weight: 400;
            color: ${dashboardColors[theme].primaryTextColor};
          }
        `}
      </style>
    </KonfhubContainer>
  );
};

export default WidgetEmptyState;
